/**
 * PATH: packages/job-hub/src/jobs/qa/qaPhotoAccept.ts
 * FILE_ID: JOBHUB-QA-PHOTO-ACCEPT-001
 * PURPOSE: Photo accept strings shared by the source menu and its tests.
 */
export const QA_PHOTO_ACCEPT = [
  'image/*',
  'image/heic',
  'image/heif',
  'image/svg+xml',
  '.heic',
  '.heif',
  '.HEIC',
  '.HEIF',
  '.svg',
  '.SVG',
  '.bmp',
  '.BMP',
  '.tif',
  '.TIF',
  '.tiff',
  '.TIFF',
  '.avif',
  '.AVIF',
  '.jxl',
  '.JXL',
  '.jfif',
  '.JFIF',
  '.dng',
  '.DNG',
  '.raw',
  '.RAW',
].join(',')

export const QA_PHOTO_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'heif',
  'svg',
  'bmp',
  'tif',
  'tiff',
  'avif',
  'jxl',
  'jfif',
  'dng',
  'raw',
  'ico',
  'jp2',
]

const PHOTO_TYPE_BY_EXTENSION: Record<string, string> = {
  heic: 'image/heic',
  heics: 'image/heic',
  heif: 'image/heif',
  heifs: 'image/heif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  jfif: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  avif: 'image/avif',
  ico: 'image/x-icon',
  jxl: 'image/jxl',
}

export function fileReadyForUpload(file: File): File {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? ''
  if (file.type && file.type !== 'application/octet-stream') return file
  const mapped = PHOTO_TYPE_BY_EXTENSION[extension]
  if (!mapped) return file
  return new File([file], file.name, { type: mapped, lastModified: file.lastModified })
}
